module.exports = __webpack_public_path__ + "static/media/edit.582c46bf.svg";